import { hover } from '@testing-library/user-event/dist/hover';
import React from 'react'
import {useState, useRef, useEffect} from 'react';
import { useSelector} from 'react-redux'
import py_img from '../img/python_icon.webp'
import gh_img from '../img/github_logo.png'

function ProjectsContent() {
    const font = '"Terminal ", monospace'
    const [currpage, setPage] = useState(0)
    const [hoverState0, setHover0] = useState(false) 
    const [hoverState1, setHover1] = useState(false) 
    const [hoverState2, setHover2] = useState(false) 
    const [hoverState3, setHover3] = useState(false) 
    const [hoverState4, setHover4] = useState(false) 
    const ref = useRef();
    const windowCheck = useSelector((state) => state.shower.window);
    useEffect(() => {
        if(windowCheck.find((w) => w.windowID === 'projects-window').reset){
          reset()
        }
    },[windowCheck.find((w) => w.windowID === 'projects-window').reset])
    
    const reset = () => {
        enterPage(0)
    }

    const setHover0True = () => {
        setHover0(true)
    }
      
    const setHover0False = () => {
        setHover0(false)
    }

    const setHover1True = () => {
        setHover1(true)
    }
      
    const setHover1False = () => {
        setHover1(false)
    }


    const setHover2True = () => {
        setHover2(true)
    }
      
    const setHover2False = () => {
        setHover2(false)
    }

    const setHover3True = () => {
        setHover3(true)
    }
      
    const setHover3False = () => {
        setHover3(false)
    }

    const setHover4True = () => {
        setHover4(true)
    }
      
    const setHover4False = () => {
        setHover4(false)
    }

    const unHover = () => { 
        setHover0(false)
        setHover1(false)
        setHover2(false)
        setHover3(false)
        setHover4(false)
    }

    const enterPage = (pageNum) => {
        setPage(pageNum)
        unHover()
    }
    const homep = () => {
        return (
            <div style={{
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center'
            }}>
                <div onMouseEnter={setHover0True} onMouseLeave={setHover0False} onClick={() => enterPage(1)} style={{
                    //textAlign: 'left',
                    cursor: 'pointer'
                    }}>
                    <h3>
                        {hoverState0 ? '👉 MeowShop 👈' : 'MeowShop'}
                    </h3>
                </div>
            
                <div onMouseEnter={setHover1True} onMouseLeave={setHover1False} onClick={() => enterPage(2)}  style={{
                    //textAlign: 'left',
                    cursor: 'pointer'
                        }}>
                    <h3>
                        {hoverState1 ? '👉 HandyESP 👈' : 'HandyESP'}
                    </h3>
                </div>

                <div onMouseEnter={setHover2True} onMouseLeave={setHover2False} onClick={() => enterPage(3)}  style={{
                    //textAlign: 'left',
                    cursor: 'pointer'
                    }}>
                    <h3>
                        {hoverState2 ? '👉 MycoChamber 👈' : 'MycoChamber'}
                    </h3>
                </div>

                <div onMouseEnter={setHover3True} onMouseLeave={setHover3False} onClick={() => enterPage(4)}  style={{
                    //textAlign: 'left',
                    cursor: 'pointer'
                    }}>
                    <h3>
                        {hoverState3 ? '👉 FPGA Voice Effects using DE10-Lite FPGA board 👈' : 'FPGA Voice Effects using DE10-Lite FPGA board'}
                    </h3>
                </div>

                <div onMouseEnter={setHover4True} onMouseLeave={setHover4False} onClick={() => enterPage(5)}  style={{
                //textAlign: 'left',
                cursor: 'pointer'
                    }}>
                    <h3>
                        {hoverState4 ? '👉 Whale Game: 5 round gambling game on a FPGA. 👈' : 'Whale Game: 5 round gambling game on a FPGA.'}
                    </h3>
                </div> 
            </div>
        )
    }

    const page1 = () => {
        return (
            <div id='meowShopPage' style={{
                display: 'flex',
                flexFlow: 'column',
                marginLeft: '10%',
                marginRight: '10%',
                overflowX: 'hidden',
                fontFamily: font,
            }}>
                
                <h1>
                    MeowShop
                </h1>
                <a href='https://github.com/dan-v4/MeowShop' rel="noreferrer" target={"_blank"} style={{
                    verticalAlign: 'middle',
                    //width: '20%',
                    marginLeft: 'auto',
                    marginRight: '0',
                    textAlign: 'center',
                }}>
                    github repo
                </a>
                <p>
                Discord bot for small-scale e-commerce. Essentially creates a shop for your server. Transactions are through DMs to ensure privacy. Utilizes MongoDB for the database. Uses Discord.py to utilize Discord API.
                </p>
                <img alt='sample of bot being used' src='https://user-images.githubusercontent.com/85653267/129063204-9ceb874b-b4cc-4a69-a426-29796c0da442.png'></img>
                <br/>
                <img alt='sample of bot being used' src='https://user-images.githubusercontent.com/85653267/129059243-56ce30e7-59fc-46c2-88c5-d374bdf2b53a.png'></img>
                <br/>
                <img alt='sample of bot being used' src='https://user-images.githubusercontent.com/85653267/129059630-52fb77a7-a27b-4b95-b58b-7c0953fcbc66.png'></img>
            </div>
        )
    }

    const page2 = () => {
        return (
            <div id='handyESPPage' style={{
                display: 'flex',
                flexFlow: 'column',
                marginLeft: '10%',
                marginRight: '10%',
                overflowX: 'hidden',
                fontFamily: font,
            }}>
                <h1>
                    HandyESP
                </h1>
                <a href='https://github.com/dan-v4/Handy-ESP' rel="noreferrer" target={"_blank"} style={{
                    verticalAlign: 'middle',
                    //width: '20%',
                    marginLeft: 'auto',
                    marginRight: '0',
                    textAlign: 'center',
                }}>
                    github repo
                </a>
                <p>
                The goal of this project is to turn an ESP32 into a handheld device with basic functions. Functions such as text editor, image viewer, calculator, etc. The device uses an SD CARD for storage and a 2.8" 240x160 pixel TFT Display which is controlled by an ILI9341. Both these devices are SPI slaves to the ESP32. The project uses the ESP-IDF framework and is coded in C.
                </p>
                <h2>Implemented</h2>
                <ul>
                    <li>Basic LCD driver</li>
                    <li>Basic settings (change background and font colour)</li>
                    <li>Button handling</li>
                    <li>Initializing SPI bus and devices</li>
                    <li>SD Card writing and reading</li>
                    <li>Main menu animations and flow</li>
                </ul>
                <h2>To be implemented</h2>
                <ul>
                    <li>Text editor</li>
                    <li>Frame Buffer</li>
                    <li>File Explorer</li>
                    <li>Calculator</li>
                    <li>Expand on Settings</li>
                </ul>
                <h2>Future applications possibly implemented</h2>
                <ul>
                    <li>Paint App</li>
                    <li>Emulator</li>
                </ul>
            </div>
        )
    }

    const page3 = () => {
        return (
            <div id='mycoChamberPage' style={{
                display: 'flex',
                flexFlow: 'column',
                marginLeft: '10%',
                marginRight: '10%',
                overflowX: 'hidden',
                fontFamily: font,
            }}>
                <h1>
                    MycoChamber
                </h1>
                <a href='https://github.com/dan-v4/MycoChamber' target={"_blank"} rel="noreferrer" style={{
                    verticalAlign: 'middle',
                    //width: '20%',
                    marginLeft: 'auto',
                    marginRight: '0',
                    textAlign: 'center',
                }}>
                    github repo
                </a>
                <p>
                    Fruiting chamber using an ESP32 to automate humidity control , light control, and air exhaust. Features a local website accesible through your ESP32 IP address. From this website, you can control humidity, light, and fan time. There are also graphs to visualize humidity and temperature over time.
                    <br></br>
                    You must upload data to spiffs.
                </p>
                <h2>
                    MonotubTracker
                </h2>
                <p>
                Sketch to control monotub light and track humidity and temperature. Includes webserver.
                </p>
            </div>
        )
    }

    const page4 = () => {
        return (
            <div id='fpgaVEPage' style={{
                display: 'flex',
                flexFlow: 'column',
                marginLeft: '10%',
                marginRight: '10%',
                overflowX: 'hidden',
                fontFamily: font,
            }}>
                <h1>
                    FPGA Voice Effects using DE10-Lite FPGA board
                </h1>
                
                <p>
                    Final Project for EECS 3216 (Digital Systems Engineering). The aim of this project is to take in audio input and apply effects to modulate the output. The overall design can be divided into three parts: Input, Effects, Output.
                </p>
                <h2>
                    Input
                </h2>
                <p>
                    Input is from an electret microphone which is connected to an ADC.
                </p>
                <h2>
                    Effects
                </h2>
                <p>
                    The output from the ADC is then passed through bandpass filters. From here, effects selected by the user can be applied to each channel. After the effects are applied, the different channels are mixed.
                </p>
                <h2>
                    Output
                </h2>
                <p>
                    Output is through a Sigma-Delta DAC.
                </p>
            </div>
        )
    }

    const page5 = () => {
        return (
            <div id='whaleGamePage' style={{
                display: 'flex',
                flexFlow: 'column',
                marginLeft: '10%',
                marginRight: '10%',
                overflowX: 'hidden',
                fontFamily: font,
            }}>
                <h1>
                Whale Game: 5 round gambling game on a FPGA.
                </h1>
                <p>
                A 5 round gambling game where two players try to earn as much points as possible. Player with the
                most points win. Game is played by pasing the FPGA board around. Players can input using the buttons and switches on the board. Round number, player turn, points, and other info can be displayed on the 7 segment LED displays. 
                    <h2>Rounds</h2>
                    <ol type='1'>
                        <li> 
                            <b>Number Guess</b> – Each player input a number they think the dealer (FPGA) will roll. The
                            closer the number they guess the higher the reward.
                        </li>
                        <li>
                            <b>Slot Machine</b> – Each player gets a chance to play the slot machine. The more matches they get
                            the more points they win. Jackpot gets extra bonus.
                        </li>
                        <li>
                            <b>Russian Roulette</b> – There can be 6 clicks. One click is considered the losing click. If a player
                            clicks the losing click the other player wins the jackpot. However, if the player calls the losing click the
                            player wins the jackpot.
                        </li>
                        <li>
                            <b>Combination</b> – Each player will get a chance to input a combination through the switches on
                            the board. Getting all combinations correctly will result in jackpot win. Each correct switch is 10 points.
                            Each wrong switch is -9 points.

                        </li>
                        <li>
                            <b>All In</b> – Each player gets a hand of cards. For this round, players are betting if their hand is
                            stronger, weaker, or a draw compared to the other player. If a player guesses correctly, they win all the
                            points of the other player. If both players guess correctly or incorrectly, no points are won. 
                        </li>
                    </ol>
                </p>
            </div>
        )
    }

    
    const balls = () => {
        if(currpage === 0){
            return(homep())
        }else if(currpage === 1){
            return (page1())
        }else if(currpage === 2){
            return (page2())
        }else if(currpage === 3){
            return (page3())
        }else if(currpage === 4){
            return (page4())
        }else if(currpage === 5){
            return (page5())
        }
    }

    //rgb(243,214,208)
    const backToHome = () =>{
        setPage(0)
    }
  return (
    <div ref={ref} id={'projects-content'} style= {{
        display: 'flex',
        flexFlow: 'column',
        overflowX: 'hidden',
        fontFamily: font,
    }}>
        
        <div  style={{
            backgroundColor: 'rgb(235, 186, 164)',
            marginLeft: '0.5%',
            marginTop: '0.5%',
            width: '2em',
            height: '2em',
            
            display: currpage === 0 ? 'none':'inline',
            position: 'fixed',
        }}>
            <button onClick={() => backToHome()} style={{
                //textAlign: 'center',
                backgroundColor: 'rgb(235, 186, 164)',
                verticalAlign: 'center',
                fontSize: '100%',
                cursor: 'pointer',
                fontSize:'100%',
                border: 'none'
            }}> 
                ⬅️ 
            </button>
        </div>
        <br></br>
        <div id={'projects-body-content'} style={{
            display: 'flex',
            flexFlow: 'column',
            overflowX: 'hidden',
            marginLeft: '10%',
            marginRight: '10%',
        }}>
            <h1 style={{
            
            }}>
                Project Browser
            </h1>
            {balls()}
        </div>
        
          
    </div>
  )
}

export default ProjectsContent